// extracted by mini-css-extract-plugin
module.exports = {"nav":"CreatorPageNav_nav__3GA6c","left":"CreatorPageNav_left__2bi5q","right":"CreatorPageNav_right__Lxwv6"};